<div class="list-item-user">
  <app-photo size="m" [type]="'photo'" [rounded]="true" [text]="user | userDisplayableName: 'short'"></app-photo>

  <div class="list-item-user__info">
    <span class="text_size-m text_color-01 text_line-1">
      {{ user | userDisplayableName }}
    </span>

    <span class="text_size-xs text_color-03 text_truncate text_line-2">
      {{ registrationLabel }}
    </span>
  </div>
</div>
